import { AdmAuth, Yn } from "@/constants/code";
import { AdmListRequestDto } from "@/dto/AdmDto";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

/**
 * 관리자 목록을 불러온다
 * @returns
 */
export default function useList() {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  const [admRequest, setAdmRequest] = useState<AdmListRequestDto>({
    page: parseInt(searchParams.get("page") || "1"),
    limit: parseInt(searchParams.get("limit") || "10"),
    keyword: searchParams.get("keyword") || undefined,
    admAuth: (searchParams.get("admAuth")?.split(",") as AdmAuth[]) || [],
    useYn: (searchParams.get("useYn")?.split(",") as Yn[]) || [],
  });
  const [rowsPerPage, setRowsPerPage] = useState<number>(
    parseInt(searchParams.get("limit") || "10")
  );
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const handleDetail = (admIdntfcId: number) => {
    try {
      setIsLoading(true);
      navigate(`/admins/${admIdntfcId}`);

      
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (
    _: React.MouseEvent<HTMLButtonElement> | null,
    page: number
  ) => {
    searchParams.set("page", page.toString());
    setSearchParams((prev) => {
      prev.set("page", page.toString());
      prev.set("limit", "10");

      setRowsPerPage(10);

      return new URLSearchParams(prev);
    });
  };

  const handleRowsPerPageChange = (
    d: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const newLimit = d.target.value;

    setRowsPerPage(parseInt(newLimit));
    setSearchParams((prev) => {
      prev.set("limit", newLimit);
      prev.set("page", "1");
      return new URLSearchParams(prev);
    });
  };

  const handleReset = () => {
    setAdmRequest({
      page: 1,
      limit: 10,
      keyword: "",
      admAuth: [],
      useYn: [],
    });
    setSearchParams((prev) => {
      prev.set("page", "1");
      prev.set("limit", "10");
      prev.set("keyword", "");
      prev.set("admAuth", "");
      prev.set("useYn", "");
      return new URLSearchParams(prev);
    });
  };

  const handleSearch = (value: AdmListRequestDto) => {
    setAdmRequest(value);
    setSearchParams((prev) => {
      prev.set("page", "1");
      prev.set("limit", "10");
      prev.set("keyword", value.keyword || "");

      if (value.admAuth!.length > 0) {
        prev.set("admAuth", value.admAuth!.join(","));
      }

      if (value.useYn!.length > 0) {
        prev.set("useYn", value.useYn!.join(","));
      }

      return new URLSearchParams(prev);
    });
  };

  return {
    handleDetail,
    handlePageChange,
    handleRowsPerPageChange,
    handleSearch,
    handleReset,
    rowsPerPage,
    admRequest,
    isLoading,
  };
}
